import { createUseStyles } from "react-jss";
import { apaTheme } from "../../constants/theme";

export const useStyles = () => {
  return createUseStyles({
    container: {
      display: "flex",
      width: "377px",
      gap: "8px",
      flexDirection: "column",
      alignItems: "flex-start",
      border: `1px solid ${apaTheme.color.border.brand.default}`,
      boxSizing: "border-box",
    },
    requestsContainer: {
      display: "flex",
      width: "500px",
      gap: "8px",
      flexDirection: "column",
      alignItems: "flex-start",
      border: `1px solid ${apaTheme.color.border.brand.default}`,
      boxSizing: "border-box",
    },
    title: {
      color: "#7B7B7B",
      fontSize: "16px",
      fontWeight: 600,
      lineHeight: "20px",
    },
    headerWrapper: {
      display: "flex",
      justifyContent: "space-between",
      flexDirection: "row",
      padding: "16px 8px 16px 16px",
      alignItems: "center",
      width: "100%",
      backgroundColor: "#FDFDFD",
      boxSizing: "border-box",
    },
    closeIconWrapper: {
      cursor: "pointer",
    },
    tabsContainer: {
      display: "flex",
      padding: "0px 8px",
      alignItems: "flex-start",
      borderBottom: "2px solid #B9BEC7",
      backgroundColor: "#FDFDFD",
      boxSizing: "border-box",
      width: "100%",
      gap: "16px",
    },
    bodyContainer: {
      padding: "8px 8px 0px 8px",
      boxSizing: "border-box",
      width: "100%",
    },
    tab: {
      display: "flex",
      padding: "4px 12px",
      cursor: "pointer",
      justifyContent: "center",
      alignItems: "center",
      color: `${apaTheme.color.text.neutral.tertiary}`,
      fontSize: "14px",
      fontWeight: 400,
      lineHeight: "20px",
    },
    activeTab: {
      display: "flex",
      padding: "4px 12px",
      cursor: "pointer",
      justifyContent: "center",
      alignItems: "center",
      color: `${apaTheme.color.text.neutral.default}`,
      fontSize: "14px",
      fontWeight: 400,
      lineHeight: "20px",
      borderBottom: `2px solid ${apaTheme.color.border.brand.default}`,
    },
    innerBodyContainer: {
      display: "flex",
      padding: "16px 8px 8px 8px",
      boxSizing: "border-box",
      width: "100%",
      gap: "16px",
      alignItems: "flex-start",
      height: "600px",
      overflowY: "auto",
    },
    buttonsWrapper: {
      display: "flex",
      padding: "16px 16px",
      flexDirection: "row",
      alignItems: "flex-start",
      backgroundColor: "#FDFDFD",
      boxSizing: "border-box",
      width: "100%",
      justifyContent: "space-between",
      gap: "16px",
      marginTop: "auto",
    },
    btn: {
      height: "32px !important",
      borderRadius: "8px !important",
      padding: "8px 16px !important",
      width: "50%",
    },
  })();
};
